import type { ComponentSchema } from '../../../../../schema-types'
import { schema as bannerSchema } from './banner.schema'
import { schema as headerSchema } from './header.schema'
import { schema as heroSchema } from './hero.schema'
import {
  announcementBarSchema, blogSchema, brandsSchema, compareSchema, couponSchema, ctaSchema, flashSaleSchema,
  lookbookBannerSchema, productGridSchema, productSliderSchema, testimonialsSchema, wishlistSchema,
} from './library.schema'
import {
  bannerCarouselSchema, categoryBentoSchema, comboSpotlightSchema, corporateBandSchema, instagramFeedSchema, newArrivalsSchema,
  offerBannerSchema, productRailSchema, promisesSchema, reviewsSchema, storySchema,
} from './home.schema'

/**
 * Neon Cinema's own schemas (additive fields its markup reads), layered over lightings1BaseSchemas.
 * `chrome` may replace headerSchema, footerSchema, floatingButtonsSchema or mobileNavSchema.
 */
export const neonCinemaSchemas: {
  componentSchemas: Record<string, ComponentSchema>
  chrome: Partial<Record<'headerSchema' | 'footerSchema' | 'floatingButtonsSchema' | 'mobileNavSchema', ComponentSchema>>
} = {
  componentSchemas: {
    'hero': heroSchema,
    'banner': bannerSchema,
    'announcement-bar': announcementBarSchema,
    'flash-sale': flashSaleSchema,
    'product-slider': productSliderSchema,
    'product-grid': productGridSchema,
    'lookbook-banner': lookbookBannerSchema,
    'testimonials': testimonialsSchema,
    'brands': brandsSchema,
    'blog': blogSchema,
    'cta': ctaSchema,
    'wishlist': wishlistSchema,
    'compare': compareSchema,
    'coupon': couponSchema,
    'banner-carousel': bannerCarouselSchema,
    'category-bento': categoryBentoSchema,
    'combo-spotlight': comboSpotlightSchema,
    'corporate-band': corporateBandSchema,
    'instagram-feed': instagramFeedSchema,
    'new-arrivals': newArrivalsSchema,
    'offer-banner': offerBannerSchema,
    'product-rail': productRailSchema,
    'promises': promisesSchema,
    'reviews': reviewsSchema,
    'story': storySchema,
  },
  chrome: { headerSchema },
}
